import React from 'react';
import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import Hiring from './Hiring.js';
import * as page from './enum.js';

class Machine extends React.Component{

    constructor(props){
       super(props);
       this.state = {
            flag : page.Pages.Home,
            Modal_Check : "Overview",
            Modal_title : "Title",
       }
    }

    Module = () => {
        console.log("Hello");
        var Ov = document.querySelector('#Bottom_Border_line');
        var Mod = document.querySelector('#Bottom_Border_line1');
        var Fee = document.querySelector('#Bottom_Border_line2');
        var Con = document.querySelector('#Bottom_Border_line3');
        var Ben = document.querySelector('#Bottom_Border_line4');
        Mod.style.borderBottom = "2px solid";
        Fee.style.borderBottom = "none";
        Con.style.borderBottom = "none";
        Ben.style.borderBottom = "none";
        Ov.style.borderBottom = "none";
        this.setState({
                    ...this.state,
                    Modal_Check : "Module",
        });
    }

    Overview = () => {
        console.log("Hello");
        var Ov = document.querySelector('#Bottom_Border_line');
        var Mod = document.querySelector('#Bottom_Border_line1');
        var Fee = document.querySelector('#Bottom_Border_line2');
        var Con = document.querySelector('#Bottom_Border_line3');
        var Ben = document.querySelector('#Bottom_Border_line4');
        Mod.style.borderBottom = "none";
        Fee.style.borderBottom = "none";
        Con.style.borderBottom = "none";
        Ben.style.borderBottom = "none";
        Ov.style.borderBottom = "2px solid";
        this.setState({
                    ...this.state,
                    Modal_Check : "Overview",
        });
    }

    Fee = () => {
        console.log("Hello");
        var Ov = document.querySelector('#Bottom_Border_line');
        var Mod = document.querySelector('#Bottom_Border_line1');
        var Fee = document.querySelector('#Bottom_Border_line2');
        var Con = document.querySelector('#Bottom_Border_line3');
        var Ben = document.querySelector('#Bottom_Border_line4');
        Mod.style.borderBottom = "none";
        Fee.style.borderBottom = "2px solid";
        Con.style.borderBottom = "none";
        Ben.style.borderBottom = "none";
        Ov.style.borderBottom = "none";
        this.setState({
                    ...this.state,
                    Modal_Check : "Fee",
        });
    }

    Contact = () => {
        console.log("Hello");
        var Ov = document.querySelector('#Bottom_Border_line');
        var Mod = document.querySelector('#Bottom_Border_line1');
        var Fee = document.querySelector('#Bottom_Border_line2');
        var Con = document.querySelector('#Bottom_Border_line3');
        var Ben = document.querySelector('#Bottom_Border_line4');
        Mod.style.borderBottom = "none";
        Fee.style.borderBottom = "none";
        Con.style.borderBottom = "2px solid";
        Ben.style.borderBottom = "none";
        Ov.style.borderBottom = "none";
        this.setState({
                    ...this.state,
                    Modal_Check : "Contact",
        });
    }

    Benefits = () => {
        var Ov = document.querySelector('#Bottom_Border_line');
        var Mod = document.querySelector('#Bottom_Border_line1');
        var Fee = document.querySelector('#Bottom_Border_line2');
        var Con = document.querySelector('#Bottom_Border_line3');
        var Ben = document.querySelector('#Bottom_Border_line4');
        Mod.style.borderBottom = "none";
        Fee.style.borderBottom = "none";
        Con.style.borderBottom = "none";
        Ben.style.borderBottom = "2px solid";
        Ov.style.borderBottom = "none";
        this.setState({
                    ...this.state,
                    Modal_Check : "Benefits",
        });
    }

    Check = () => {
        var ch = this.state.Modal_Check;
        if(ch === "Overview"){
            return (
                <div>
                    <h4 class="mt-2">About Machine Learning Training-</h4>
                    <p>This Machine Learning course will also help you understand the connections between theory and practice in
                    Machine Learning and help you master topics like Reinforcement Learning, Deep Learning, advanced techniques like
                    Dimensionality Reduction,Support Vector Machines, etc to prepare you for the role of Machine Learning Engineer.</p>
                    <h4 class="mt-2">Data Science Course Objective-</h4>
                    <div>The learning objectives of python course in ScimoX:</div>
                    <div class="mt-1">1. Internalize the concepts & constructs of machine learning techniques.</div>
                    <div class="mt-1">2. Learn to create your own Modeling on Machine Learning.</div>
                    <div class="mt-1">3. Master In Python Basic & Advanced Project.</div>
                    <div class="mt-1">4. Master In Conceptualization, summarization and Representation of data.</div>
                    <div class="mt-1">5. Work on Big data computing environment, Modern data analytics technologies like Hadoop and MapReduce.</div>
                    <div class="mt-1">7. Work on Statistics, Workflow of R tool, Data mining, reporting/visualization, fundamental of SQL,
                     classified algorithms, supervised, unsupervised machine learning algorithms and lot more.</div>
                    <div class="mt-1">8. 100% Interview Guarantee.</div>
                </div>
            )
        }else if(ch === "Module"){
            return (
                <div id="Scroll_Me">
                    <h4 class="mt-3">Data Science Course Syllabus-</h4>
                    <div class="mt-3">1. Basic:</div>
                    <div>Python language introduction, Python 3 basics, Keywords in Python, Namespaces and Scope in Python, Structuring
                        Python Programs, Decision making.</div>
                    <div class="mt-2">2. Input/Output:</div>
                    <div>Taking input in Python, Vulnerability in input() function, Python | end parameter in print(), Python | sep parameter in print().</div>
                    <div class="mt-2">3. Variables:</div>
                    <div>Variables, expression condition and function Maximum possible value of an integer in python, Global and local
                        variables in python Packing and unpacking arguments in python, End parameter in Python.</div>
                    <div class="mt-2">4. Control Flow:</div>
                    <div>Loops, Loops and Control Statements (continue, break and pass) in Python, Looping technique in python, range vs
                    xrange on python, Programs for printing pyramid technique in python Chaining comparison in python, else with for switch
                     function.</div>
                    <div class="mt-2">5. Modules and Packages:</div>
                    <div>Modules, Importing module, Standard Module – sys, Standard Module – OS ,The dir Function, Package Exercise.</div>
                    <div class="mt-2">6. Classes Objects:</div>
                    <div>Introduction classes and objects, Creating Classes, Instance Methods, Special class method, Inheritance, Method
                        overriding, Data handling Exercise.</div>
                    <div class="mt-2">7. Plotting for exploratory data analysis (EDA):</div>
                    <div>Data-point, vector, observation, Input variables/features/dimensions/independent variable , Output Variable/
                    Class Label/ Response Label/ ,Scatter-plot: 2D, 3D.</div>
                    <div class="mt-2">8. Advance Library:</div>
                    <div>Multi threading ,Thread, Starting a thread , Threading module, array, numpy, Tkinter programming Tkinter widget.</div>
                    <div class="mt-2">9. Probability and Statistics:</div>
                    <div>Introduction to Probability and Stats, Gaussian/Normal Distribution, Uniform Distribution and random number
                    generators Bernoulli and Binomial distribution, Log-normal and power law distribution: Correlation ,
                    Confidence Intervals</div>
                    <div class="mt-2">10. Linear Algebra:</div>
                    <div>Point/Vector (2-D, 3-D, n-D) ,Dot product and angle between 2 vectors,Projection, unit vector , Equation of a line
                     (2-D), plane(3-D) and hyperplane (n-D) , Square, Rectangle, Hyper-cube and Hyper-cuboid.</div>
                    <div class="mt-2">11. Dimensionality reduction and Visualization:</div>
                    <div>What is dimensionality reduction? , Data representation and pre-processing , MNIST dataset (784 dimensional) ,
                        Principal Component Analysis, T-distributed stochastic neighborhood embedding (t-SNE).</div>
                    <div class="mt-2">12. Dimensionality reduction and Visualization:</div>
                    <div>Dataset overview: Amazon Fine Food reviews , Data Cleaning: Deduplication., Featurizations: convert text to numeric
                     vectors, Code samples, Exercise: t-SNE visualization of Amazon reviews with polarity based color-coding.</div>
                    <div class="mt-2">13. Classification and Regression Models-K-Nearest Neighbors:</div>
                    <div>Foundations, K-Nearest Neighbors , K-Nearest Neighbors ,Classification algorithms in various situations:
                        Imbalanced vs balanced dataset, Multi-class classification, k-NN, given a distance or similarity matrix,
                        Train and test set differences, Handling categorical and numerical features.</div>
                    <div class="mt-2">14. Performance measurement of models:</div>
                    <div>Accuracy, Confusion matrix, TPR , FPR , FNR, TNR , Median absolute deviation (MAD) ,Receiver Operating
                        Characteristic Curve (ROC) curve and AUC.</div>
                    <div class="mt-2">15. Logistic Regression:</div>
                    <div>Geometric intuition, Sigmoid function & Squashing , Optimization problem, Hyperparameter search: Grid Search and
                        Random Search , Column Standardization, Collinearity of features, Train & Run time space and time complexity.</div>
                    <div class="mt-2">16. Support Vector Machines (SVM):</div>
                    <div>Geometric intuition, Mathematical derivation, Loss minimization: Hinge Loss, Kernel trick, Polynomial kernel,
                        RBF-Kernel, Domain specific Kernels.</div>
                    <div class="mt-2">17. Decision Trees:</div>
                    <div>Geometric Intuition: Axis parallel hyperplanes,Sample Decision tree, Building a decision Tree, Overfitting and
                     Underfitting,Train and Run time complexity, Regression using Decision Trees,Cases, Exercise: Decision Trees on Amazon
                     reviews dataset.</div>
                    <div class="mt-2">18. Ensemble Models:</div>
                    <div>What are ensembles?, Bootstrapped Aggregation (Bagging) , Boosting,Stacking models, Cascading classifiers,
                        Kaggle competitions vs Real world.</div>
                    <div class="mt-2">19. Unsupervised learning/Clustering: K-Means (2):</div>
                    <div>What is Clustering? ,Unsupervised learning,Applications., Metrics for Clustering,K-Means.</div>
                    <div class="mt-2">20. Hierarchical clustering:</div>
                    <div>Agglomerative & Divisive, Dendrograms , Proximity methods: Advantages and Limitations, Time and Space Complexity,
                        Code sample, Exercise: Amazon food reviews.</div>
                    <div class="mt-2">21. DBSCAN (Density based clustering):</div>
                    <div>Density based clustering ,MinPts and Eps: Density,Core, Border and Noise points, Density edge and Density
                        connected points,DBSCAN Algorithm.</div>
                    <div class="mt-2">22. Recommender Systems and Matrix Factorization:</div>
                    <div>Problem formulation: Movie reviews, Content based vs Collaborative Filtering, Similarity based Algorithms,Matrix
                    Factorization,Hyperparameter tuning, Matrix Factorization for recommender systems: Netflix Prize Solution, Cold Start
                    problem, Word Vectors using MF,Eigen-Faces.</div>
                    <div class="mt-2">23. Deep Learning: Neural Networks:</div>
                    <div>History of Neural networks and Deep Learning., How Biological Neurons work?, Diagrammatic representation: Logistic
                     Regression and Perceptron,Multi-Layered Perceptron ,Training a single-neuron model,Training an MLP: Chain rule.</div>
                    <div class="mt-2">24. Deep Learning: Deep Multi-layer perceptrons:</div>
                    <div>1980s to 2010s , Dropout layers & Regularization,Rectified Linear Units (ReLU), Weight initialization,Batch
                        Normalization, Gradient monitoring and Clipping,Softmax for multi-class classification, How to train a Deep MLP? ,
                        Auto Encoders.</div>
                    <div class="mt-2">25. Deep Learning: Tensorflow and Keras:</div>
                    <div>Overview, GPU vs CPU for Deep Learning , Google Colaboratory ,TensorFlow, MNIST classification in Keras ,
                        Hyperparameter tuning in Keras.</div>
                    <div class="mt-2">26. Deep Learning: Convolutional Neural Nets:</div>
                    <div>Biological inspiration: Visual Cortex , Convolution,Convolutional layer,Max-pooling,CNN Training: Optimization,
                    ImageNet dataset , Data Augmentation, Convolution Layers in Keras ,AlexNet ,VGGNet ,Residual Network.</div>
                    <div class="mt-2">27. Deep Learning:Recurrent Neural Networks:</div>
                    <div>Why RNNs,Recurrent Neural Network, Training RNNs: Backprop,Types of RNNs,Need for LSTM/GRU,GRUs,LSTM, Deep RNN,
                        Bidirectional RNN.</div>
                </div>
            )
        }else if(ch === "Fee"){
            return (
                <div>
                    <h4 class="mt-3">Fee Structure & Course Duration-</h4>
                    <div class="mt-3"><strong>• Course :-</strong> Python Basic and Advance.</div>
                    <div class="mt-3"><strong>• Level :-</strong> Master Certification.</div>
                    <div class="mt-3"><strong>• Batch :-</strong> Weekends, Weekdays.</div>
                    <div class="mt-3"><strong>• Format :-</strong> Class Room Training.</div>
                    <div class="mt-3"><strong>• Course Fee :-</strong> (Machine Learning With Python ): Rs.23000 /-Machine Learning: Rs .19000 /-
                    </div>
                    <div class="mt-3"><strong>• Course Duration :-</strong> 3 Months.</div>
                    <div class="mt-3"><strong>• Training Location :-</strong> HazaratGanj Branch, Lucknow.</div>
                </div>
            );
        }else if(ch === "Contact"){
            return (
                <div>
                    <h4 class="mt-3">HR Counsellor-</h4>
                    <div class="mt-2"><strong>Mr. Deepak Kanuajia.</strong></div>
                    <div class="mt-2"><strong>Email :-</strong> Deepak@scimox.com.</div>
                    <div class="mt-2"><strong>Phone :-</strong> (+91) - 7011907181.</div>
                    <h4 class="mt-3">IT Trainer-</h4>
                    <div class="mt-2"><strong>Mr. Rishi Kanuajia.</strong></div>
                    <div class="mt-2"><strong>Email :-</strong> Rishi@scimox.com.</div>
                    <div class="mt-2"><strong>Phone :-</strong> (+91) - 9457384665.</div>
                </div>
            );
        }else if(ch === "Benefits"){
            return (
                <div>
                    <h4 class="mt-3">Benefits of Scimox Training Institute-</h4>
                    <div class="mt-3"><strong>1. 3 Month days Month Complete Data Science Course With Live Project.</strong></div>
                    <div class="mt-2"><strong>2. Syllabus Made by As Per Company Job Description.</strong></div>
                    <div class="mt-2"><strong>3. Resume Modification As Per Company Norm.</strong></div>
                    <div class="mt-2"><strong>4. Working on Live Project Training Module.</strong></div>
                    <div class="mt-2"><strong>5. Hands on 10 +Project.</strong></div>
                    <div class="mt-2"><strong>6. 1 Year Membership.</strong></div>
                    <div class="mt-2"><strong>7. 100% Interview Guarantee.</strong></div>
                    <div class="mt-2"><strong>8. After Placement Career Mentoring.</strong></div>
                </div>
            );
        }
    }

    render(){
        return (
             <div id="Modal_Content_Color">
                <div class="d-flex justify-content-around">
                    <div onClick={this.Overview}><p id="Bottom_Border_line"><strong>Overview</strong></p></div>
                    <div onClick={this.Module}><p id="Bottom_Border_line1"><strong>Course</strong></p></div>
                    <div onClick={this.Fee}><p id="Bottom_Border_line2"><strong>Fee</strong></p></div>
                    <div onClick={this.Contact}><p id="Bottom_Border_line3"><strong>Contact</strong></p></div>
                    <div onClick={this.Benefits}><p id="Bottom_Border_line4"><strong>Scimox</strong></p></div>
                </div>
                <div>{this.Check()}</div>
             </div>
        );
    }
}

export default Machine;